import React, { useEffect } from "react";
import * as Styles from "../common/styles/TradeInAem";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import { getInternalLink } from "../../../utils/navUtils";
import { TradeInAemLabel } from "../../../utils/labels";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import AemDealerFinder, { AemDealerFinderService } from "../../../../common-deprecated/components/AemDealerFinder";
import { getAPI } from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import { tradeInAemDealerSetDealer } from "../../../redux/actions/TradeInAemDealerActions";
import { type DealerResultType, A2DContext } from "../../../../common-deprecated/utils/dealerConstants";
import { trackStepDealerFinder } from "../../../utils/tracking";
import { tradeInAemUpdateExtraInfoProp } from "../../../redux/actions/TradeInAemVehicleActions";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { useDispatch } from "../../../../shared-logic/redux/store";
import { showBackCtaOnStepComponent } from "../../../utils/utils";

const DealerFinderContainer = (): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const previouslySelectedDealer = useTradeInAemSelector((state) => state.tradeInAemDealer.dealer);
    const tradeInAemModelSelect = useTradeInAemSelector((state) => state.tradeInAemModelSelect);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);

    const csl = useTradeInCsl();
    const trackingParams = useTrackingParams();
    const prevStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "prev");
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");
    const onDealerSelect = (selectedDealer: DealerResultType | null): void => {
        dispatch(tradeInAemDealerSetDealer(selectedDealer));
        dispatch(tradeInAemUpdateExtraInfoProp("dealerId", selectedDealer?.id || ""));
        nextStep.onClick?.();
    };

    useEffect(() => {
        trackStepDealerFinder(trackingParams, tradeInAemModelSelect);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styles.Main noTopMargin>
            <AemDealerFinder
                onDealerSelect={onDealerSelect}
                dealerSearchEndpoint={`${getAPI(commonSettings, "dealers", "/search")}`}
                dealerDetailEndpoint={getAPI(commonSettings, "dealer")}
                previouslySelectedDealer={previouslySelectedDealer}
                serviceFilter={AemDealerFinderService.TradeInAppraisal}
                settings={csl.dealerFinderSettings}
                a2dContext={A2DContext.TI}
            />

            {showBackCtaOnStepComponent(currentStep, csl.enabledNavSteps) && (
                <Styles.Container large>
                    <Styles.ButtonWrapper>
                        <Button.Link m={0} as="a" href={prevStep.href} onClick={prevStep.onClick} hasIcon>
                            <IconWrapper>
                                <Icon variant="arrowLeft" />
                            </IconWrapper>
                            <Text.Button>
                                <TradeInAemLabel label="tradeInAemBack" />
                            </Text.Button>
                        </Button.Link>
                    </Styles.ButtonWrapper>
                </Styles.Container>
            )}
        </Styles.Main>
    );
};
export default DealerFinderContainer;
